import DiscontinuedOverlay from './DiscontinuedOverlay';

export default DiscontinuedOverlay;
